import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes an input size in bytes and transforms it into a more human-readable format.
 * It first checks if the size is zero, and if so, it returns '0 Bytes'.
 * Then, it takes the log base 1024 of the size to find out which unit to use, rounds
 * it down to the nearest whole number to find the index, and then uses
 * that index to select the appropriate unit from the sizes array.
 */
@Pipe({
  standalone: true,
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(size: number): string {
    if (size <= 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const sizeIndex = Math.floor(Math.log(size) / Math.log(k));
    return `${Math.round(size / Math.pow(k, sizeIndex))} ${sizes[sizeIndex]}`;
  }
}
